import { ReportHandler } from 'web-vitals';
import { AnalyticsConsentService } from './services/AnalyticsConsentService';
import { GoogleAnalyticsService } from './services/GoogleAnalyticsService';

type WebVitalMetric = Parameters<ReportHandler>[0];

const pendingMetrics: WebVitalMetric[] = [];

const sendMetricToGoogleAnalytics = (metric: WebVitalMetric): void => {
  GoogleAnalyticsService.trackEvent('web_vital', {
    event_category: 'Web Vitals',
    event_label: metric.id,
    metric_name: metric.name,
    metric_delta: metric.delta,
    metric_value: metric.value,
    value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
    non_interaction: true
  });
};

const flushPendingMetrics = (): void => {
  if (!GoogleAnalyticsService.isEnabled()) return;

  while (pendingMetrics.length > 0) {
    const metric = pendingMetrics.shift();
    if (metric) {
      sendMetricToGoogleAnalytics(metric);
    }
  }
};

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (GoogleAnalyticsService.isConfigured()) {
    AnalyticsConsentService.subscribe((state) => {
      if (state === 'granted') {
        flushPendingMetrics();
      }
    });
  }

  const handlePerfEntry: ReportHandler = (metric) => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
      onPerfEntry(metric);
    }

    if (!GoogleAnalyticsService.isConfigured()) return;

    if (GoogleAnalyticsService.isEnabled()) {
      sendMetricToGoogleAnalytics(metric);
      return;
    }

    pendingMetrics.push(metric);
  };

  if ((onPerfEntry && onPerfEntry instanceof Function) || GoogleAnalyticsService.isConfigured()) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(handlePerfEntry);
      getFID(handlePerfEntry);
      getFCP(handlePerfEntry);
      getLCP(handlePerfEntry);
      getTTFB(handlePerfEntry);
    });
  }
};

export default reportWebVitals;
